export const round = (number: number, precision = 0) => {
  const factor = Math.pow(10, precision)
  return Math.round(number * factor) / factor
}
